export default {
	"f348671efa5ce1d8fa52d9190ecf71db": "亲爱的用户您好:",
	"ec1a0cd4ddebcceb233d4bde4fa59048": "因春节放假，各区域快递陆续停运，2025年1月28日-2025年1月31日（共计4天），叫叫将暂停年度系统包首月订单（首次激活产生的订单）与成长豆兑换订单的实物配送，2025年2月1日恢复正常发货运输，给您带来不便敬请谅解，祝您春节愉快！",
	"b003a908fd945588f60f1ce22ad23b24": "叫叫"
}
